import approve from 'approvejs';

export function validateField(field) {
  let check = true;
  let result = null;
  field.errors = [];
  if (field && field.length && field.length > 0) {
    for (let i = 0; i < field.length; i++) {
      const currentSubField = field[i];
      for (let subItem in currentSubField) {
        if (subItem === 'id' || subItem === 'name') {
          continue;
        }
        try {
          result = approve.value(
            currentSubField[subItem].value,
            currentSubField[subItem].rules
          );
          if (result.errors.length > 0) {
            check = false;
            currentSubField[subItem].errors = Array.from(result.errors);
          } else {
            currentSubField[subItem].errors = [];
          }
        } catch (e) {
          console.warn('verification error', currentSubField, `field: "${subItem}"`, 'error:', e)
        }
      }
    }
  } else {
    if (field.value || field.rules) {
      try {
        result = approve.value(field.value, field.rules);
        if (result.errors.length > 0) {
          check = false;
          field.errors = Array.from(result.errors);
        } else {
          field.errors = [];
        }
      } catch (e) {
        console.warn(`verification error for value. field: "${field}"`, 'error:', e)
      }
    }
  }

  return {
    field,
    check,
  };
}

export function validateFields(fields) {
  let check = true;
  let result = null;
  for (let field in fields) {
    fields[field].errors = [];
    if (fields[field] && fields[field].length && fields[field].length > 0) {
      for (let i = 0; i < fields[field].length; i++) {
        const currentSubField = fields[field][i];
        for (let subItem in currentSubField) {
          if (subItem === 'id' || subItem === 'name') {
            continue;
          }
          try {
            result = approve.value(
              currentSubField[subItem].value,
              currentSubField[subItem].rules
            );
            if (result.errors.length > 0) {
              check = false;
              currentSubField[subItem].errors = Array.from(result.errors);
            } else {
              currentSubField[subItem].errors = [];
            }
          } catch (e) {
            console.warn('verification error', currentSubField, `field: "${subItem}"`, 'error:', e)
          }
        }
      }
    } else {
      if (!fields[field].value && !fields[field].rules) {
        continue;
      }

      try {
        result = approve.value(fields[field].value, fields[field].rules);
        if (result.errors.length > 0) {
          check = false;
          fields[field].errors = Array.from(result.errors);
        } else {
          fields[field].errors = [];
        }
      } catch (e) {
        console.warn('verification error for value', fields, `field: "${field}"`, 'error:', e)
      }

    }
  }
  return {
    fields,
    check,
  };
}

approve.addTest({
  expects: ['message', 'onValidate'],
  //message: '{message}',
  //onValidate: value => true
  message: 'Custom Test',
  validate: (value, pairs) => {
      if (pairs.message) {
          console.log(pairs.message);
      }
      return pairs.onValidate(value)
  }
}, "custom");


// WEBPACK FOOTER //
// ./src/utils/validate.js